// Public, indexable SEO landing page for GCSE English Language + Literature revision.
import GCSESubjectHub from './GCSESubjectHub';

const config = {
  subjectKey: 'english',
  path: '/gcse-english-revision',
  appHubPath: '/english',
  crumbLabel: 'GCSE English Revision',
  seoTitle: 'GCSE English Revision — Language & Literature',
  seoDescription:
    'Ace GCSE English Language & Literature. AI-marked essays, set-text deep dives (Macbeth, ACC, Inspector Calls), Power & Conflict and exam technique. Try free.',
  eyebrow: 'GCSE English · AQA Language + Literature',
  heroChip: 'bg-rose-100 text-rose-700 border border-rose-200',
  h1: 'GCSE English Revision built for Grade 9',
  heroLede:
    'Stop second-guessing your essays. Grade9Ready marks your responses against AO1-AO4 with WWW + EBI feedback, walks you through every set text (Macbeth, A Christmas Carol, An Inspector Calls, Power & Conflict) and trains you on Lang Paper 1 + Paper 2 question by question.',

  coverageLede:
    'From Shakespeare to unseen poetry, from Q1 retrieval to a 40-mark transactional response — every English Language and Literature module is covered with AI-marked practice and examiner-aligned guidance.',
  coverage: [
    { title: 'Macbeth',                       body: '16 topics: plot, 5-act summaries, characters (Macbeth, Lady M, Witches), themes (ambition, guilt, fate), Jacobean context, exam technique.' },
    { title: 'A Christmas Carol',             body: '13 topics: 5-stave summaries, Scrooge arc, Cratchits, the Spirits, themes (redemption, poverty), Victorian context.' },
    { title: 'An Inspector Calls',            body: '14 topics: 3-act summaries, every Birling + the Inspector + Gerald, themes (responsibility, class, gender), 1912 vs 1945 context.' },
    { title: 'Power & Conflict Anthology',    body: 'All 15 named poems + comparison technique + anthology overview.' },
    { title: 'Unseen Poetry',                 body: '5-step method, form & structure, language & imagery, comparison technique.' },
    { title: 'Language Paper 1',              body: 'Q1-Q4 walk-throughs + descriptive + narrative writing, with AI-marked challenges per question.' },
    { title: 'Language Paper 2',              body: 'Q1-Q4 + transactional writing + bias / argument analysis.' },
    { title: 'GCSE Skill Primers',            body: '19th-century language (3 topics), Spoken Language endorsement (4), AO awareness, Plan→Draft→Edit cycle.' },
  ],

  tipLabels: [
    'Macbeth essays',
    'A Christmas Carol',
    'Lang Paper 1 Q4',
  ],

  finalCtaH2: 'Get an examiner inside your essay',
  finalCtaLede:
    'Open your free 7-day Early Access. Submit any answer, get AO1-AO4 feedback in seconds, see exactly what level you\'re writing at.',

  faqs: [
    {
      q: 'Are the set texts AQA-aligned?',
      a: 'Yes — Macbeth, A Christmas Carol, An Inspector Calls and the Power & Conflict anthology are all on the AQA Lit specification. Each topic flags the relevant Paper / Section and time allocation.',
    },
    {
      q: 'How does the AI essay marking work?',
      a: 'Submit a paragraph or full response and the AI marker returns an estimated grade band, AO1 / AO2 / AO3 (and AO4 where relevant) feedback, what went well, even better if, target grade actions, and a model improvement. It also classifies the dominant error type (missing AO3 evaluation, missing technique label, etc.) so you can track your weak spot.',
    },
    {
      q: 'Are there past papers?',
      a: 'Yes — 30 AQA-style past-paper questions across the three Lit set texts (10 per text, 2017-2023 + sample years) with full examiner guidance, plus full Language Paper 1 and Paper 2 walk-throughs.',
    },
    {
      q: 'What about End-of-Section tests?',
      a: 'Every English section ends with a cumulative 20-question End-of-Section Test pulled from the topics in that section, with grade banding (Emerging → Excellent / Grade 9) and a per-topic revision list.',
    },
    {
      q: 'Is Spoken Language covered?',
      a: 'Yes — the Spoken Language endorsement gets four dedicated topics inside the GCSE Skill Primers section.',
    },
    {
      q: 'Which exam board is this for?',
      a: 'Primarily AQA, with significant overlap for Edexcel and OCR pupils. The set texts (Macbeth, ACC, Inspector Calls) and Power & Conflict cluster are all common across boards.',
    },
  ],
};

export default function GCSEEnglishRevisionHub() {
  return <GCSESubjectHub config={config} />;
}
